import {
  CREATEWHEELCHAIRREQUEST,
  DELETEWHEELCHAIRREQUEST,
  GETWHEELCHAIRREQUEST,
  UPDATEWHEELCHAIRREQUEST,
  GETONEWHEELCHAIRREQUEST,
} from "../actions/types";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEWHEELCHAIRREQUEST:
      return { ...state, wheelchairRequestSaveStatus: action.payload.success };
    case GETWHEELCHAIRREQUEST:
      return { ...state, wheelchairRequestList: action.payload.data };
    case UPDATEWHEELCHAIRREQUEST:
      return {
        ...state,
        wheelchairRequestUpdateStatus: action.payload.success,
      };
    case DELETEWHEELCHAIRREQUEST:
      return {
        ...state,
        wheelchairRequestDeleteStatus: action.payload.success,
      };
    case GETONEWHEELCHAIRREQUEST:
      return { ...state, wheelchairRequestDetail: action.payload.data };
    default:
      return state;
  }
}
